export default "__VITE_ASSET__Cipf6sKT__"